"use client";
import React from "react";
import Image from "next/image";
import Link from "next/link";
import YoutubeIcon from "./YoutubeIcon";
import {YoutubeVideo} from "@/types";
import {Locale} from "@/i18n-config";
import {sendGAEvent} from "@next/third-parties/google";

export default function YoutubeSection({video, eventName, locale}: {video: YoutubeVideo; eventName: string; locale: Locale}) {
  const youtubeUrl = `https://www.youtube.com/watch?v=${video.videoId}`;

  const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // Prevent the default behavior (immediate navigation)
    e.preventDefault();

    // Fire Yandex Metrika event if available
    if (typeof window !== "undefined" && typeof window.ym === "function") {
      window.ym(94764572, "reachGoal", eventName);
    }

    // Fire Google Analytics event using your provided function
    sendGAEvent("event", eventName);

    // Open the YouTube URL in a new browser tab

    window.open(youtubeUrl, "_blank");
  };

  const {sectionId, thumbnail, en_title, en_subtitle, en_description, ru_title, ru_subtitle, ru_description} = video;

  const title = locale === "ru" ? ru_title : en_title;
  const subtitle = locale === "ru" ? ru_subtitle : en_subtitle;
  const description = locale === "ru" ? ru_description : en_description;

  return (
    <div className="relative z-10 py-10 px-8" id={sectionId}>
      <div className="flex flex-col lg:flex-row items-center gap-6 xs:gap-12 sm:gap-24">
        {/* Left Column */}
        <div className="lg:w-2/5 mb-7 lg:mb-0 relative">
          <div className="mb-7">
            <h2 className={`font-inter-display font-bold  text-4xl xs:text-5xl sm:text-6xl  mb-5`}>{title}</h2>
            <p className={`font-inter-display font-bold text-2xl xs:text-3xl sm:text-4xl text-gray-500 mb-5`}>{subtitle}</p>
            <p className={`text-lg xs:text-lg sm:text-lg`}>{description}</p>
          </div>
        </div>

        {/* Right Column (Thumbnail + YouTube Link) */}
        <div className="lg:w-3/5 relative w-full">
          <div className="relative w-full h-[250px] sm:h-[350px] lg:h-[400px] mt-8">
            <Link href={youtubeUrl} onClick={handleLinkClick} target="_blank" rel="noopener noreferrer" className="block relative w-full h-full">
              <Image src={thumbnail} alt="Visit our YouTube Channel" className="absolute inset-0 w-full h-full object-cover" width={200} height={300} />
              <div className="absolute inset-0 flex items-center justify-center">
                <YoutubeIcon />
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
